import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailComposeControlSections"*/ './lazyIndex'),
    { name: 'MailComposeControlSections' }
);

export const lazyGetSensitivitySections: LazyImport<
    typeof lazyIndex.getSensitivitySections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSensitivitySections);
export const lazyGetProtectEncryptSections: LazyImport<
    typeof lazyIndex.getProtectEncryptSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getProtectEncryptSections);
export const lazyGetSignatureSections: LazyImport<
    typeof lazyIndex.getSignatureSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSignatureSections);
export const lazyGetEditorSections: LazyImport<
    typeof lazyIndex.getEditorSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getEditorSections);
export const lazyGetTemplateSections: LazyImport<
    typeof lazyIndex.getTemplateSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTemplateSections);
export const lazyGetQuickPartsSections: LazyImport<
    typeof lazyIndex.getQuickPartsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getQuickPartsSections);
export const lazyShowImportTemplateDialog: LazyImport<
    typeof lazyIndex.showImportTemplateDialog,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.showImportTemplateDialog);
export const lazyGetShowFieldsSections: LazyImport<
    typeof lazyIndex.getShowFieldsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getShowFieldsSections);
export const lazyGetTrackingSections: LazyImport<
    typeof lazyIndex.getTrackingSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTrackingSections);
export const lazyGetSaveAsFileSections: LazyImport<
    typeof lazyIndex.getSaveAsFileSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSaveAsFileSections);
export const lazyShowSaveTemplateDialog: LazyImport<
    typeof lazyIndex.showSaveTemplateDialog,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.showSaveTemplateDialog);
export const lazyForwardItemAsOFTAttachment: LazyImport<
    typeof lazyIndex.forwardItemAsOFTAttachment,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.forwardItemAsOFTAttachment);
